import { render, staticRenderFns } from "./ChangeImageWidget.vue?vue&type=template&id=0b538a34&"
import script from "./ChangeImageWidget.vue?vue&type=script&lang=js&"
export * from "./ChangeImageWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports